import { render, staticRenderFns } from "./ApplicationDecisionItemCard.vue?vue&type=template&id=21e5b06c&"
import script from "./ApplicationDecisionItemCard.vue?vue&type=script&lang=js&"
export * from "./ApplicationDecisionItemCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports